const $tabs = $('.js-tabs');
const $tabToggler = $('.js-tab-toggler');

const tabs = {
  initialize() {
    if ($tabs.length) {
      this.createListeners();
    }
  },

  createListeners() {
    const { hash } = window.location;

    if (typeof hash !== 'undefined') {
      $tabs.find(`a[href="${hash}"]`).tab('show');
    }

    $tabs.on('click', 'a', ({ currentTarget }) => {
      $(currentTarget).tab('show');
      window.location.hash = currentTarget.hash;
    });

    $tabToggler.on('click', ({ currentTarget }) => {
      $tabs.find(`a[href="${currentTarget.dataset.tabTarget}"]`).tab('show');
      window.location.hash = currentTarget.dataset.tabTarget;
    });
  },
};

export default tabs;
